module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/admin/pen_w-387bd45ee37e72fda42d45cbc72cd4e3.svg&quot;;"